import * as React from 'react';
import { Props } from 'react';

import './DialogView.scss';
import i18next from 'i18next';

interface BaggageDialogViewProps extends Props<BaggageDialogView> {

}

export class BaggageDialogView extends React.Component<BaggageDialogViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='dialog-client-message'>
                    {i18next.t('how_much_baggage')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    {i18next.t('what_airline')}
                </div>
                <div className='clearfix' />
                <div className='dialog-client-message'>
                    {i18next.t('aeroflot')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    <div dangerouslySetInnerHTML={{ __html: i18next.t('aeroflot_answer') }} />
                    <div className='baggage-dialog-more-button'>
                        {i18next.t('read_more')}
                    </div>
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/BaggageDialogView.tsx